import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function ModalHeader({
  title,
  description,
  onClose,
  size,
  type,
  icon,
}) {
  const iconHeader = icon || 'ri-history-fill';

  function leftIcon(iconType) {
    if (iconType === 'leftIcon') {
      return <i className={classNames('modal-icon', `modal-icon-${size}`, iconHeader)} />;
    }
    if (iconType === 'success') {
      return <i className={classNames('modal-icon', 'modal-icon-success', 'ri-checkbox-circle-fill')} />;
    }
    if (iconType === 'error') {
      return <i className={classNames('modal-icon', 'modal-icon-error', 'ri-error-warning-fill')} />;
    }
    if (iconType === 'warning') {
      return <i className={classNames('modal-icon', 'modal-icon-warning', 'ri-error-warning-fill')} />;
    }
    if (iconType === 'info') {
      return <i className={classNames('modal-icon', 'modal-icon-warning', 'ri-information-fill')} />;
    }
    return null; // Ensure a value is returned at the end
  }

  return (
    <div className={classNames('pgn__modal-header', `modal-header-${size}`)}>
      <div className="modal-header-left">
        {type === 'leftIcon' && size === 'sm' && (
          <i className={classNames('modal-icon', `modal-icon-${size}`, iconHeader)} />
        )}
        {size === 'lg' && leftIcon(type)}
        <div className={classNames('modal-header-texts', `modal-header-texts-${size}`)}>
          <span className="modal-header-title">{title}</span>
          {size === 'lg' && <p className="modal-header-description">{description}</p>}
        </div>
      </div>
      <div
        className="modal-header-right"
        onClick={onClose}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === 'Enter') { onClose(); }
        }}
      >
        <i className="modal-icon-close ri-close-fill" />
      </div>
    </div>
  );
}

ModalHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'lg']),
  type: PropTypes.oneOf(['basic', 'leftIcon', 'success', 'error', 'warning', 'info']),
  icon: PropTypes.string,
};

ModalHeader.defaultProps = {
  title: '',
  description: '',
  onClose: () => { },
  size: 'sm',
  type: 'basic',
  icon: 'ri-history-fill',
};

export default ModalHeader;
